import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSimulation } from '../contexts/SimulationContext';

interface UseSubscriptionExpirationHandlerProps {
  onClose?: () => void;
}

export function useSubscriptionExpirationHandler({ onClose }: UseSubscriptionExpirationHandlerProps = {}) {
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const { user } = useAuth();
  const { dispatch } = useSimulation();

  const handleApiError = useCallback((error: any) => {
    // Check if this is a subscription expiration error
    if (error.response && 
        error.response.status === 403 && 
        error.response.data.error === 'Subscription cancelled') {
      
      // Check if the user is an admin
      setIsAdmin(error.response.data.isAdmin || (user?.role === 'ADMIN'));
      setIsExpiredModalOpen(true);
      
      // If the processing modal is open, close it immediately
      dispatch({ type: 'SET_LOADING', payload: false });
      
      return true; // Handled the error
    }
    
    return false; // Did not handle the error
  }, [user?.role, dispatch]);

  const closeExpiredModal = useCallback(() => {
    setIsExpiredModalOpen(false);
    
    // Ensure the loading state is set to false when subscription expired modal is closed
    dispatch({ type: 'SET_LOADING', payload: false });
    
    if (onClose) {
      onClose();
    }
  }, [onClose, dispatch]);

  return {
    isExpiredModalOpen,
    isAdmin,
    handleApiError,
    closeExpiredModal
  };
} 